export class Video {
  _id?: string;
  youtubeCode: string = '';
  poster: string = '';
  position: number = 0;
  title: string = '';
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/video.model.ts